import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import "./Login.css";

function Register() {
    const [email, setEmail] = useState(''); // ✅ Fix 1
    const [password, setPassword] = useState('');
    const [first_name, setFirstName] = useState('');
    const [last_name, setLastName] = useState('');
    const [role, setRole] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            const baseUrl = process.env.NODE_ENV !== 'production' 
          ? 'http://localhost:3001'
          : 'https://server.phumulanintulistudio.com';
            const response = await axios.post(`${baseUrl}/register`, {
                first_name,
                last_name,
                email,
                password,
                role
            });

            console.log('Server Response:', response.data); // ✅ Fix 3

            if (response.status === 201) {
                setSuccess("Registration successful! Check your email for verification.");
                setTimeout(() => navigate('/login'), 3000); // Redirect to login after 3 seconds
            }
        } catch (err) {
            console.error('Registration Error:', err.response || err);
            setError(err.response?.data?.error || 'Registration failed. Try again.');
        }
    };

    return (
        <div className="login">
            <div className="loginContainer">
                <h2>Register</h2>
                <form onSubmit={handleSubmit}>
                    <label>First Name:</label>
                    <input
                        type="text"
                        name="first_name"
                        value={first_name}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                    />

                    <label>Last Name:</label>
                    <input
                        type="text"
                        name="last_name"
                        value={last_name}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                    />

                    <label>Email:</label>
                    <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />

                    <label>Password:</label>
                    <input
                        type="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    <label>Role:</label>
                    <select name="role" value={role} onChange={(e) => setRole(e.target.value)} required>
                        <option value="">Select Role</option> {/* ✅ Fix 2 */}
                        <option value="admin">Admin</option>
                        <option value="collector">Collector</option>
                        <option value="team">Team</option>
                        <option value="writer">Writer</option>
                        <option value="publisher">Publisher</option>
                        <option value="editor">Editor</option>
                    </select>

                    {error && <p className="error">{error}</p>}
                    {success && <p className="success">{success}</p>}

                    <button type="submit">Register</button>
                </form>
                <p className="other-links">
                    Already have an account? <Link to="/login">Login here</Link>
                </p>
            </div>
        </div>
    );
}

export default Register;
